import clsx from "clsx";
import { Tag, TagColor } from "react-migration/components/Tag";
import { DataPanel } from "react-migration/components/DataPanel";
import { SingleDesignation } from "react-migration/domains/constraints/typings/applicationTypes/SingleDesignation";
import { protectedSmallDateFormatter } from "react-migration/domains/planning/utils/protectedDateFormatter";
import hasFeature from "src/js/stores/user/actions/hasFeature";
import Feature from "src/js/stores/user/Feature";
import { useNavigate } from "react-router-dom";
import { AssessmentLayerTabUS } from "../../Bundle/Workbench/AssessmentTab/types";

function getAttribute(designation: SingleDesignation, key: string) {
  return designation.designation_attributes.find((attr) => attr.key === key)?.value ?? "";
}

export interface EnvironmentPermitDetailProps {
  onTitleClick?: (application: SingleDesignation) => void;
  application: SingleDesignation;
}

const map = {
  environmental_permits_approved: TagColor.GREEN,
  environmental_permits_pending: TagColor.ORANGE,
  environmental_permits_withdrawn: TagColor.ORANGE,
  environmental_permits_rejected: TagColor.RED,
  environmental_permits_unknown: TagColor.DEFAULT,
};

export function EnvironmentPermitDetail({ onTitleClick, application }: EnvironmentPermitDetailProps) {
  const ref = getAttribute(application, "application_ref_#");
  const title = application.display_name;
  const date_received = getAttribute(application, "application_submission_date");

  const dateDisplay = protectedSmallDateFormatter(date_received);

  const statusId = application.sub_category!.id as keyof typeof map;
  const statusDisplayName = application.sub_category?.display_name;
  const statusColor = map[statusId];

  const hasAccess = hasFeature(Feature.buildingPermits);
  const navigate = useNavigate();

  return (
    <article
      className="bg-white border border-border-action rounded-xl p-4 flex flex-col cursor-default"
      data-testid="planning-application-detail-mini-card"
    >
      <div className="flex flex-row gap-x-2">
        <h1
          onClick={() => {
            console.log("location", location);
            hasAccess ? onTitleClick?.(application) : navigate(`/assessment/${AssessmentLayerTabUS.PERMITS}`);
          }}
          className={clsx("text-sm font-medium text-text-base-active truncate", {
            "hover:text-text-base-active-hover cursor-pointer": !!onTitleClick,
          })}
        >
          {ref}
        </h1>
      </div>
      <div className="mt-1">
        <p title={title} className="text-sm font-normal text-black line-clamp-2 h-10">
          {title}
        </p>
      </div>
      <DataPanel.Grid columns={2}>
        <DataPanel.Cell title="Status">
          <Tag color={statusColor} title={`status: ${statusDisplayName}`} tag={statusDisplayName} />
        </DataPanel.Cell>
        <DataPanel.Cell title="Submission date">
          <span title={`date received: ${dateDisplay}`} className="line-clamp-1 text-sm">
            {dateDisplay}
          </span>
        </DataPanel.Cell>
      </DataPanel.Grid>
    </article>
  );
}
